import React, { useEffect, useState } from 'react';
import './Projects.css';
import { FaReact, FaNodeJs, FaAws, FaDatabase, FaDocker, FaAngular, FaGithub, FaGitlab, FaGoogle, FaJava, FaJenkins, FaMicrosoft, FaPython, FaVuejs } from 'react-icons/fa';
import { SiRubyonrails, SiPostgresql, SiMongodb, SiMaterialdesign, SiHtml5, SiCss3, SiJquery, SiAwsamplify, SiFirebase, SiTerraform, SiArgo, SiPytorch, SiTensorflow, SiVite, SiWebassembly, SiTypescript, SiReactrouter, SiFfmpeg, SiPwa, SiWebgl, SiOpengl, SiJavascript, SiGithubpages } from 'react-icons/si';
import { Project } from '../types';
import { getProjects } from '../queries/getProjects';
import { GrDeploy, GrKubernetes } from "react-icons/gr";

const techIcons: { [key: string]: JSX.Element } = {
  "ReactJS": <FaReact />,
  "NodeJS": <FaNodeJs />,
  "AWS": <FaAws />,
  "PostgreSQL": <SiPostgresql />,
  "MongoDB": <SiMongodb />,
  "Ruby On Rails": <SiRubyonrails />,
  "Material UI": <SiMaterialdesign />,
  "HTML5": <SiHtml5 />,
  "CSS3": <SiCss3 />,
  "jQuery": <SiJquery />,
  "AWS-ECS": <SiAwsamplify />,
  'Cognito': <FaAws />,
  'Lambda': <FaAws />,
  'ECS': <FaAws />,
  'Jenkins': <FaJenkins />,
  'Docker': <FaDocker />,
  'GraphQL': <FaDatabase />,
  'CI/CD': <FaGitlab />,
  'GitLab': <FaGitlab />,
  'GitHub': <FaGithub />,
  'Heroku': <GrDeploy />,
  'Netlify': <GrDeploy />,
  'Firebase': <SiFirebase />,
  'GCP': <FaGoogle />,
  'Azure': <FaMicrosoft />,
  'Kubernetes': <GrKubernetes />,
  'Terraform': <SiTerraform />,
  'ArgoCD': <SiArgo />,
  'Java': <FaJava />,
  'Spring Boot': <FaJava />,
  'Python': <FaPython />,
  'Node.js': <FaNodeJs />,
  'Express.js': <FaNodeJs />,
  'Hibernate': <FaJava />,
  'Maven': <FaJava />,
  'Gradle': <FaJava />,
  'JUnit': <FaJava />,
  'Mockito': <FaJava />,
  'Jest': <FaReact />,
  'React': <FaReact />,
  'Angular': <FaAngular />,
  'Vue.js': <FaVuejs />,
  'Next.js': <FaReact />,
  'Gatsby': <FaReact />,
  'Nuxt.js': <FaVuejs />,
  'Redux': <FaReact />,
  'Vuex': <FaVuejs />,
  'Tailwind CSS': <SiCss3 />,
  'Bootstrap': <SiCss3 />,
  'JQuery': <SiJquery />,
  'FastAPI': <FaPython />,
  'React.js': <FaReact />,
  'React/Vite': <FaReact />,
  'Uvicorn': <FaPython />,
  'REST APIs': <FaDatabase />,
  'Vercel': <GrDeploy />,
  'Render': <GrDeploy />,
  'Groq API': <FaPython />,
  'Supabase': <SiPostgresql />,
  'JWT': <FaDatabase />,
  'JWT Authentication': <FaDatabase />,
  'Row Level Security': <SiPostgresql />,
  'Hugging Face Spaces': <FaPython />,
  'Pandas': <FaPython />,
  'NumPy': <FaPython />,
  'scikit-learn': <FaPython />,
  'PyTorch': <SiPytorch />,
  'TensorFlow': <SiTensorflow />,
  'Streamlit': <FaPython />,
  'ETL Pipelines': <FaPython />,
  'Feature Engineering': <FaPython />,
  'Cross-validation': <FaPython />,
  'Minimax Algorithm': <FaPython />,
  'FIFO Queue': <FaPython />,
  'Prompt Engineering': <FaPython />,
  'pdfplumber': <FaPython />,
  'Vite': <SiVite />,
  'WebAssembly': <SiWebassembly />,
  'FFmpeg': <SiFfmpeg />,
  'TypeScript': <SiTypescript />,
  'React Router': <SiReactrouter />,
  'PWA': <SiPwa />,
  'IndexedDB': <FaDatabase />,
  'WebGL2': <SiWebgl />,
  'GLSL': <SiOpengl />,
  'JavaScript': <SiJavascript />,
  'Web Audio API': <SiJavascript />,
  'Canvas 2D': <SiHtml5 />,
  'Web Workers': <SiJavascript />,
  'GitHub Pages': <SiGithubpages />,
};


const Projects: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([])
  
  useEffect(() => { 
    async function fetchProjects() {
      const data = await getProjects();
      setProjects(data);
    }
    
    fetchProjects()
  }, [])
  
  if (projects.length === 0) return <div>Loading...</div>;

  return (
    <div className="projects-container">
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div
            key={index}
            className="project-card"
            style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}
          >
            <img src={project.image.url} alt={project.title} className="project-image" />
            <div className="project-details">
              <h3>
                {project.liveUrl ? (
                  <a
                    href={project.liveUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    {project.title}
                  </a>
                ) : (
                  project.title
                )}
              </h3>
              <p>{project.description}</p>
              {project.note && (
                <p style={{ color: '#f5c518', fontWeight: 600 }}>⚠️ {project.note}</p>
              )}
              {(project.liveUrl || project.githubUrl) && (
                <p className="project-links">
                  {project.liveUrl && (
                    <>
                      <a className="project-link" href={project.liveUrl} target="_blank" rel="noopener noreferrer">
                        Live
                      </a>
                    </>
                  )}
                  {project.liveUrl && project.githubUrl && <span> | </span>}
                  {project.githubUrl && (
                    <a className="project-link" href={project.githubUrl} target="_blank" rel="noopener noreferrer">
                      GitHub
                    </a>
                  )}
                </p>
              )}
              <div className="tech-used">
                {project.techUsed.split(', ').map((tech, i) => (
                  <span key={i} className="tech-badge">
                    {techIcons[tech] || "🔧"} {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
        <a
          href="https://github.com/MKeshav04?tab=repositories"
          target="_blank"
          rel="noopener noreferrer"
          className="project-card"
          style={{ '--delay': `${projects.length * 0.1}s`, textDecoration: 'none', color: 'inherit' } as React.CSSProperties}
        >
          <div className="project-details" style={{ display: 'grid', placeItems: 'center', minHeight: 220 }}>
            <h3>More projects on GitHub →</h3>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Projects;
